import { https,httpsFile } from "./http";
import * as types from '../../mutation_types';

const state = {
    id:'',
    page:1,
    currentpage:5,
    company:'',
    status:'',
    user:'',
    supplier_from:'',
    supplier_to:'',
    material:'',
    date_from:'',
    date_to:'',
    search:'',
    loading:false,
    data:{},
    details:{},
    discount:false,
    discountdata:[],
    discount_loading:false,
    discounterror:'',
    history:false,
    historydata:[],
    history_loading:false,
    history_err:false,
    history_err_loading:false,
    history_errdata:[],
    update_values:new FormData(),
    update_return:{},
    release_return:{},
    print_po:false,
    print_po_data:[],
    update_to_released_po:new FormData(),
};
const getters = {
    id:state=>state.id,
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    company:state=>state.company,
    status:state=>state.status,
    user:state=>state.user,
    supplier_from:state=>state.supplier_from,
    supplier_to:state=>state.supplier_to,
    material:state=>state.material,
    date_from:state=>state.date_from,
    date_to:state=>state.date_to,
    search:state=>state.search,
    loading:state=>state.loading,
    data:state=>state.data,
    details:state=>state.details,
    discount:state=>state.discount,
    discountdata:state=>state.discountdata,
    discount_loading:state=>state.discount_loading,
    discounterror:state=>state.discounterror,
    history:state=>state.history,
    historydata:state=>state.historydata,
    history_loading:state=>state.history_loading,
    update_values:state=>state.update_values,
    update_return:state=>state.update_return,
    release_return:state=>state.release_return,
    history_err:state=>state.history_err,
    history_err_loading:state=>state.history_err_loading,
    history_errdata:state=>state.history_errdata,
    print_po:state=>state.print_po,
    print_po_data:state=>state.print_po_data
};
const actions = {
    async fetchPostedPoHeaders({commit}){
        commit(types.REL_LOADING);
        let uri = `post-po-header?page=${state.page}&currentpage=${state.currentpage}&company=${state.company}&status=${state.status}
        &supplier_from=${state.supplier_from}&supplier_to=${state.supplier_to}&creator=${state.user}&date_from=${state.date_from}&date_to=${state.date_to}&matnr=${state.material}&search=${state.search}`;
        await https().get(uri).then(response=>{
            commit(types.REL_DATA,response.data);
            commit(types.REL_LOADING);
        }).catch(error=>{
            commit(types.REL_LOADING);
            console.log(error);
        })
    },
    async fetchPostedPoHeader({commit}){
        let uri = `post-po-header/${state.id}`;
        await https().get(uri).then(async response=>{
            commit(types.REL_DETAILS,response.data);
        }).catch(error=>{
            console.log(error);
        })
    },
    async fetchDiscounts({commit}){
        commit(types.REL_DISCOUNT_LOADING);
        commit(types.REL_DISCOUNT_DETAILS,state.details.discount);
        commit(types.REL_DISCOUNT_LOADING);
    },
    async updateDiscount({commit}){
        commit(types.REL_ERR_DISCOUNT,'');
        $.each(state.discountdata,(key,value)=>{
            if(value.type==='' ||value.value===''){
                commit(types.REL_ERR_DISCOUNT,'Value and Type should not be empty.');
            }
        })
        if(state.discounterror===''){
            let form_data = new FormData();
            form_data.append('discounts',JSON.stringify(state.discountdata));
            form_data.append("_method",'put');
            let uri = `wholesale-discounts/${state.id}`;
            await https().post(uri,form_data).then(response=>{
                commit(types.REL_ERR_DISCOUNT,'');
            }).catch(error=>{
                console.log(error);
                commit(types.REL_ERR_DISCOUNT,'Internal server error');
            })
        }
    },
    async fetchPoHistory({commit}){
        let uri = `activities/${state.id}/edit?subject_type=PendingPoHeader`;
        await https().get(uri).then(response=>{
            commit(types.REL_HISTORY_DATA,response.data);
        }).catch(error=>{
            console.log(error);
        })
    },
    async fetchErrorMessages({commit},data){
        commit(types.REL_HISTORY_ERR_LOADING);
        commit(types.REL_HISTORY_ERR_DATA,data);
        commit(types.REL_HISTORY_ERR_LOADING);
    },
    async updateHeader({commit}){
        let uri = `post-po-header/${state.id}`;
        await https().post(uri,state.update_values).then(response=>{
            commit(types.REL_UPDATE_RETURN,response.data);
        }).catch(error=>{
            let response = {
                status:'error',
                message:'Internal Server Error'
            };
            commit(types.REL_UPDATE_RETURN,response);
        })
    },
    async releasePo({commit}){
        let uri = `post-po-header/${state.id}`;
        return await https().post(uri,state.update_values).then(response=>{
            commit(types.REL_RETURN,response.data);

            return response;
        }).catch(error=>{
            let response = {
                status:'error',
                message:'Internal Server Error'
            };
            commit(types.REL_RETURN,response);
        })
    },
    async updateReleasedPo({commit}){
        let uri = `updateReleasedPO/${state.id}`;
        await https().post(uri,state.update_to_released_po).then(response=>{
            commit(types.REL_RETURN,response.data);
        }).catch(error=>{
            let response = {
                status:'error',
                message:'Internal Server Error'
            };
            commit(types.REL_RETURN,response);
        })
    },
    async printPo({commit}){
        let uri = `temporary-po-detail/${state.id}/edit?status=approve&post_status=${state.details.status}`;
        await https().get(uri).then(response=>{
            commit(types.REL_PRINT_PO_DATA,response.data);
        }).catch(error=>{
            console.log(error);
        })
    }
};
const mutations = {
    [types.REL_DATA](state,data){
        state.data = data;
    },
    [types.REL_LOADING](state){
        state.loading = !state.loading;
    },
    [types.REL_PAGE](state,data){
        state.page = data;
    },
    [types.REL_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.REL_SEARCH](state,data){
        state.search = data;
    },
    [types.REL_COMPANY](state,data){
        state.company = data;
    },
    [types.REL_STATUS](state,data){
        state.status = data;
    },
    [types.REL_SUPPLIER_FROM](state,data){
        state.supplier_from = data;
    },
    [types.REL_SUPPLIER_TO](state,data){
        state.supplier_to = data;
    },
    [types.REL_USER](state,data){
        state.user = data;
    },
    [types.REL_DATE_FROM](state,data){
        state.date_from = data;
    },
    [types.REL_DATE_TO](state,data){
        state.date_to = data;
    },
    [types.REL_MATERIAL](state,data){
        state.material = data;
    },
    [types.REL_ID](state,data){
        state.id = data;
    },
    [types.REL_DETAILS](state,data){
        state.details = data;
    },
    [types.REL_DISCOUNT](state){
        state.discount = !state.discount;
    },
    [types.REL_DISCOUNT_DETAILS](state,data){
        state.discountdata = data;
    },
    [types.REL_DISCOUNT_LOADING](state){
        state.discount_loading = !state.discount_loading;
    },
    [types.REL_ADD_DISCOUNT](state){
        state.discountdata.push({
            header_id:state.id,
            type:'',
            value:''
        })
    },
    [types.REL_DEL_DISCOUNT](state,index){
        state.discountdata.splice(index,1);
    },
    [types.REL_EDIT_DISCOUNT](state,data){
        let id = data.id;
        let type = data.type;
        state.discountdata[id].type = type;
    },
    [types.REL_ERR_DISCOUNT](state,data){
        state.discounterror = data;
    },
    [types.REL_HISTORY](state){
        state.history = !state.history;
    },
    [types.REL_HISTORY_DATA](state,data){
        state.historydata = data;
    },
    [types.REL_HISTORY_LOADING](state){
        state.history_loading = !state.history_loading;
    },
    [types.REL_UPDATE_DETAILS](state,data){
        state.update_values = data;
    },
    [types.REL_PO_UPDATE](state,data){
        state.update_to_released_po = data;
    },
    [types.REL_UPDATE_RETURN](state,data){
        state.update_return = data;
    },
    [types.REL_RETURN](state,data){
        state.release_return = data;
    },
    [types.REL_HISTORY_ERR](state){
        state.history_err = !state.history_err;
    },
    [types.REL_HISTORY_ERR_LOADING](state){
        state.history_err_loading = !state.history_err_loading;
    },
    [types.REL_HISTORY_ERR_DATA](state,data){
        state.history_errdata = data;
    },
    [types.REL_PRINT_PO](state){
        state.print_po = !state.print_po;
    },
    [types.REL_PRINT_PO_DATA](state,data){
        state.print_po_data = data;
    }

};
export {
    state,getters,actions,mutations
}